module.exports = __webpack_public_path__ + "img/stock6.510f8216.png";